export const getEntityObject = (entityId, entityType) => {
  if (entityId && entityType) {
    return { [entityType]: entityId }
  }
}
